import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';

export default (rootReducer, preloadedState) => createStore(
  rootReducer,
  preloadedState,
  applyMiddleware(thunk)
);